// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__cZqyI","author":"Table_author__15wUK","authorImage":"Table_authorImage__2c7t3","unreadRow":"Table_unreadRow__4QLGv"};